/**
 * Central Acremitra Pvt Ltd company profile — reused by every PDF, email
 * preview and admin-panel legal string. Single source of truth on the FE.
 */
export const COMPANY = {
  name:           'Acremitra Pvt Ltd',
  shortName:      'Acremitra',
  brand:          'Acre Mitra',
  cin:            'U62090WB2026PTC288041',
  gst:            '',
  pan:            '',
  registeredAddr: 'Acremitra Pvt Ltd, Head Office, Kolkata, West Bengal, India',
  hqLine1:        'Head Office',
  hqCityState:    'Kolkata, West Bengal, India',
  phonePrimary:   '+91 85973 10624',
  phoneSecondary: '',
  emailSupport:   'support@acremitra.com',
  emailHr:        'hr@acremitra.com',
  emailInfo:      'info@acremitra.com',
  website:        'acremitra.com',
  tagline:        'Your Trusted Real Estate Partner',
  founder:        'Sounav Mandal',
  founderTitle:   'Founder & Director',
  cofounder:      'Lisa Sen',
  cofounderTitle: 'Co-Founder & Director',
};

/** One-line legal footer for headers/footers. */
export const COMPANY_FOOTER = `${COMPANY.name} · CIN ${COMPANY.cin} · ${COMPANY.hqCityState}`;

export default COMPANY;
